import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { trans, getPagePath } from '@spotahome/soyuz/client';
import classNames from 'classnames';
import Metrics from '@spotahome/soyuz-tracking';

import { Button } from '@spotahome/ui-library';

import SectionHeading from '@spotahome/landings-common/src/components/SectionHeading';
import CheckedCircleIcon from '@spotahome/landings-common/src/components/icons/CheckedCircleIcon';
import './RefereeForm.scss';

const RefereeForm = props => {
  const [isTenant, setTenant] = useState(false);
  const [isLandlord, setLandlord] = useState(false);

  const toggleTenantProfile = () => {
    setLandlord(false);
    setTenant(prevTenant => !prevTenant);
    Metrics.ga.sendEvent(
      'tenant_pick_referred',
      'option_tenant_referred_button',
      'click_tenant_button'
    );
  };

  const toggleLandlordProfile = () => {
    setTenant(false);
    setLandlord(prevLandlord => !prevLandlord);
    Metrics.ga.sendEvent(
      'landlord_pick_referred',
      'option_landlord_referred_button',
      'click_landlord_button'
    );
  };

  const handleSubmit = event => {
    event.preventDefault();
    props.onFormSubmission({ isTenant, isLandlord });
    Metrics.ga.sendEvent(
      'register_sah',
      'sah_referred_user_button',
      'click_register_sah_referred_button'
    );
  };

  const classesOptionTenant = classNames('form__options__btn', {
    'form__options__btn--selected': isTenant
  });
  const classesOptionLandlord = classNames('form__options__btn', {
    'form__options__btn--selected': isLandlord
  });

  const renderOptions = () => (
    <div className="form__options">
      <Button
        className={classesOptionTenant}
        type="button"
        data-test="referee-form-option-tenant"
        size="big"
        color="filled"
        onClick={toggleTenantProfile}
        value={isTenant}
      >
        {isTenant && <CheckedCircleIcon className="form__icon" />}
        {trans('referee.form.option.tenant')}
      </Button>
      <Button
        className={classesOptionLandlord}
        type="button"
        data-test="referee-form-option-landlord"
        size="big"
        color="filled"
        onClick={toggleLandlordProfile}
        value={isLandlord}
      >
        {isLandlord && <CheckedCircleIcon className="form__icon" />}
        {trans('referee.form.option.landlord')}
      </Button>
    </div>
  );

  const getTermsPath = () => {
    Metrics.ga.sendEvent(
      'terms_conditions_referred',
      'terms_conditios_referred_link',
      'click_terms_conditions_link'
    );
  };

  return (
    <div className="form__wrapper">
      <SectionHeading
        text={trans('referee.form.title')}
        theme="dark"
        type="none"
      />
      <form className="form" onSubmit={handleSubmit}>
        {renderOptions()}
        <Button
          className="form__btn"
          type="submit"
          data-test="referee-form-submit"
          size="big"
          disabled={!isTenant && !isLandlord}
        >
          {trans('referee.form.input.submit')}
        </Button>
      </form>
      <p className="form__terms">
        {trans('referee.form.terms.text')}
        <a
          target="_blank"
          rel="noopener noreferrer"
          className="form__link"
          href={getPagePath('externals.referrals-terms-and-conditions')}
          onClick={getTermsPath}
          data-test="referee-link-terms"
        >
          {trans('referee.form.terms.link')}
        </a>
      </p>
    </div>
  );
};

RefereeForm.propTypes = { onFormSubmission: PropTypes.func.isRequired };

export default RefereeForm;
